<template>
  <v-navigation-drawer
    app
    temporary
    v-model="inputValue"
    right
  >
    <v-list>
      <v-list-tile>
        <v-spacer />
        <v-btn 
          icon 
          @click="toggleDrawer">
          <v-icon>close</v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        ripple
      >
        <v-list-tile-title v-text="item.text" />
      </v-list-tile>
      <v-list-tile 
        to="login"
        ripple
        @click="logout">
        <v-list-tile-action>
          Logout
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState(["drawer"]),
    items() {
      return this.$store.getters.getRoutes;
    },
    inputValue: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    }
  },

  methods: {
    ...mapMutations(["setDrawer", "toggleDrawer"]),
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>
